export const defaultPageInfo = {
    "_id": -1,
    "contact": {
        "backgroundcolor": "#ffffff",
        "button": {
            "bgcolor": "#7b5cfa",
            "bordercolor": "transparent",
            "borderradius": "4px",
            "color": "#ffffff",
            "enabled": true,
            "hoverbgcolor": "#0069d9",
            "hovercolor": "#ffffff",
            "size": "md",
            "text": "Send Message",
            "url": "#",
        },
        "cardbackground": "#f4efff",
        "contentposition": "right",
        "description": "<p>We'd love to hear from you! Let's get in touch</p>",
        "id": "contact1",
        "image": "https://zencruz-easymembr.s3.amazonaws.com/gymhomepage/67502055bfca0b906a81dfbe/1752753482087_9145.png",
        "imageposition": "left",
        "isactive": true,
        "layout": "image-left",
        "layoutorder": ["image", "content"],
        "order": 0,
        "subtitle": "<p>Get in touch</p>",
        "title": "<h2>Contact us for more</h2>",
        "type": "contact",
    },
    "footer": {
        "backgroundcolor": "#08173b",
        "color": "#ffffff",
        "content": "© 2025 Easymenbr. All rights reserved.",
        "id": "footer1",
        "isactive": true,
        "links": [
            {
                "label": "facebook",
                "check": true,
                "url": "https://www.facebook.com/"
            },
            {
                "label": "twitter",
                "check": true,
                "url": "https://twitter.com/"
            },
            {
                "label": "youtube",
                "check": false,
                "url": "https://www.youtube.com/"
            },
            {
                "label": "whatsapp",
                "check": false,
                "url": "+91 80192 96262"
            },
            {
                "label": "instagram",
                "check": true,
                "url": "https://www.instagram.com/"
            },
            {
                "label": "linkedin",
                "check": false,
                "url": "https://in.linkedin.com/"
            }
        ],
        "type": "footer",
    },
    "herosections": [
        {
            "backgroundcolor": "#f4efff",
            "button": {
                "bgcolor": "#007bff",
                "bordercolor": "transparent",
                "borderradius": "4px",
                "color": "#ffffff",
                "enabled": false,
                "hoverbgcolor": "#0069d9",
                "hovercolor": "#ffffff",
                "size": "md",
                "text": "Join Now",
                "url": "#",
            },
            "contentposition": "left",
            "description": "<p>Unlock your full potential with a stronger, healthier body and a focused mind. Embrace the journey to total wellness—because real change starts from within. State of the art fitness facility with expert trainers and Premium equipment.</p>",
            "heroimage": "https://zencruz-easymembr.s3.amazonaws.com/gymhomepage/67502055bfca0b906a81dfbe/1752753652118_2050.png",
            "id": "hero1",
            "imageposition": "right",
            "isactive": true,
            "layout": "image-left",
            "layoutorder": ["content", "image"],
            "order": 0,
            "subtitle": "<h5><span style=\"color: rgb(128, 90, 213);\">FIT YOUR BODY</span></h5>",
            "title": "<h2><span style=\"color: rgb(59, 130, 246);\">Transform</span> Your Body Elevate Your <span style=\"color: rgb(49, 130, 206);\">Life</span></h2>",
            "type": "hero",
        },
        {
            "backgroundcolor": "#ffffff",
            "button": {
                "bgcolor": "#007bff",
                "bordercolor": "transparent",
                "borderradius": "4px",
                "color": "#ffffff",
                "enabled": false,
                "hoverbgcolor": "#0069d9",
                "hovercolor": "#ffffff",
                "size": "md",
                "text": "Join Now",
                "url": "#",
            },
            "contentposition": "right",
            "description": "<p>Start your journey with strength, focus, and determination. Unlock your potential with expert trainers, top-tier equipment, and a supportive atmosphere. Every drop of sweat, every rep, and every moment in the gym brings you closer to a healthier, stronger you. This is more than fitness—it’s your transformation.</p><p><em>Let’s build it, together.</em></p>",
            "heroimage": "https://zencruz-easymembr.s3.amazonaws.com/gymhomepage/67502055bfca0b906a81dfbe/1752756818432_4719.png",
            "id": "hero-1752756742999",
            "imageposition": "left",
            "isactive": true,
            "layout": "image-right",
            "layoutorder": ["image", "content"],
            "order": 1,
            "subtitle": "<h5><span style=\"color: rgb(177, 54, 214);\">FIT YOUR BODY</span></h5>",
            "title": "<h2>Ready to make a</h2><h2>change ?</h2>",
            "type": "hero",
        },
        {
            "backgroundcolor": "#ffffff",
            "button": {
                "bgcolor": "#007bff",
                "bordercolor": "transparent",
                "borderradius": "4px",
                "color": "#ffffff",
                "enabled": false,
                "hoverbgcolor": "#0069d9",
                "hovercolor": "#ffffff",
                "size": "md",
                "text": "Join Now",
                "url": "#",
            },
            "contentposition": "left",
            "description": "<p>Stronger every day—powered by discipline and passion.Our premium facility and personalized training help you thrive.Our cutting-edge equipment, energizing environment, and results-driven programs are designed to keep you consistent and committed. </p><p><em>Stay focused. Stay fierce. Stay unstoppable.</em></p>",
            "heroimage": "https://zencruz-easymembr.s3.ap-south-1.amazonaws.com/gymhomepage/67502055bfca0b906a81dfbe/1752756864019_5766.png",
            "id": "hero-1752756820926",
            "imageposition": "right",
            "isactive": true,
            "layout": "image-right",
            "layoutorder": ["content", "image"],
            "order": 2,
            "subtitle": "<h5><span style=\"color: rgb(177, 54, 214);\">FIT YOUR BODY</span></h5>",
            "title": "<h2>Push your limits. Feel the transformation!</h2>",
            "type": "hero",
        },
        {
            "backgroundcolor": "#ffffff",
            "button": {
                "bgcolor": "#007bff",
                "bordercolor": "transparent",
                "borderradius": "4px",
                "color": "#ffffff",
                "enabled": false,
                "hoverbgcolor": "#0069d9",
                "hovercolor": "#ffffff",
                "size": "md",
                "text": "Join Now",
                "url": "#",
            },
            "contentposition": "right",
            "description": "<p>Redefine what’s possible. Transform your health with focused training and nonstop motivation. With structured programs, expert coaching, and an empowering environment, you’ll gain more than just physical results. This is your moment to rise, reshape, and reclaim your potential.</p><p><em>                                                                                    Let’s make it happen—together.</em></p>",
            "heroimage": "https://zencruz-easymembr.s3.amazonaws.com/gymhomepage/67502055bfca0b906a81dfbe/1752897872899_706.png",
            "id": "hero-1752897826423",
            "imageposition": "left",
            "isactive": true,
            "layout": "image-right",
            "layoutorder": ["image", "content"],
            "order": 3,
            "subtitle": "<h5><span style=\"color: rgb(177, 54, 214);\">FIT YOUR BODY</span></h5>",
            "title": "<h2>One ride closer to your goal!</h2>",
            "type": "hero",
        },
        {
            "backgroundcolor": "#ffffff",
            "button": {
                "bgcolor": "#007bff",
                "bordercolor": "transparent",
                "borderradius": "4px",
                "color": "#ffffff",
                "enabled": false,
                "hoverbgcolor": "#0069d9",
                "hovercolor": "#ffffff",
                "size": "md",
                "text": "Join Now",
                "url": "#",
            },
            "contentposition": "left",
            "description": "<p>Every rep is progress. Every session is a win. Start strong, finish stronger—with expert coaching and real results.Our trainers are here to guide you, challenge you, and celebrate your wins—every step of the way. With structured routines, personalized support, and cutting-edge equipment, you’ll train smarter and perform better.</p><p><em>Push your limits. Stay consistent. See the results.</em></p>",
            "heroimage": "https://zencruz-easymembr.s3.ap-south-1.amazonaws.com/gymhomepage/67502055bfca0b906a81dfbe/1752897988228_9428.png",
            "id": "hero-1752897889063",
            "imageposition": "right",
            "isactive": true,
            "layout": "image-right",
            "layoutorder": ["content", "image"],
            "order": 4,
            "subtitle": "<h5><span style=\"color: rgb(177, 54, 214);\">FIT YOUR BODY</span></h5>",
            "title": "<h2>Unleash the athlete in you!</h2>",
            "type": "hero",
        }
    ],
    "plans": {
        "backgroundcolor": "#ffffff",
        "id": "plans1",
        "isactive": false,
        "items": [
            {
                "btntext": "Choose Plan",
                "features": ["Access to gym", "Standard equipment"],
                "id": "plan-1752898156262",
                "ispopular": false,
                "name": "",
                "planid": "",
                "tagtext": "Best Sell",
                "themecolor": "#fe9200",
                "icon": "dumbbell",
            },
            {
                "btntext": "Choose Plan",
                "features": ["All Basic features", "Premium equipment", "Personal trainer"],
                "id": "plan-1752898157272",
                "ispopular": true,
                "name": "",
                "planid": "",
                "tagtext": "Best Sell",
                "themecolor": "#a4dd00",
                "icon": "crown"
            },
            {
                "btntext": "Choose Plan",
                "features": ["All Premium features", "Premium equipment", "Personal trainer", "Daily diet routine"],
                "id": "plan-1752898161920",
                "ispopular": false,
                "name": "",
                "planid": "",
                "tagtext": "Best Sell",
                "themecolor": "#68ccca",
                "icon": "hand-holding-usd"
            }
        ],
        "subtitle": "<p>Get plans</p>",
        "title": "<h2>Membership Plans</h2>",
        "type": "plans",
    },
}